import getUpdatedSanitisedCart from './getUpdatedSanitisedCart';

import sliceHandler from '../../utils/sliceHandler';

const sliceArgs = {
  SLICE_NAME: 'cart',
};

const sliceName = sliceArgs.SLICE_NAME;

const reducers = {
  updateCart: (state, action) => {
    const { payload } = action;
    const updatedCart = getUpdatedSanitisedCart(payload);

    state.loading = false;
    state.data = updatedCart;
  },
  emptyCart: (state, _action) => {
    state.loading = false;
    state.data = [];
  },
};

const slice = sliceHandler({ sliceName, reducers });

const { actions, reducer } = slice;

export const { updateCart } = actions;
export default reducer;
